import React from 'react'

import config from '../config.js'

import { MuiThemeProvider } from '@material-ui/core/styles'

import { Button } from '@material-ui/core/'

import { Link } from 'react-router-dom'

const JoinNow = () => (
  <div className="join-now">
    <MuiThemeProvider theme={config.theme}>
      <Button
        variant="contained"
        color="secondary"
        type="button"
        href="https://www.dvo.com/sign-up.php"
      >
        Join Now
      </Button>
      <Button
        variant="contained"
        color="primary"
        type="button"
        component={Link}
        to={config.baseUrl +'/login'}
      >
        Log In
      </Button>
    </MuiThemeProvider>
  </div>
)

export default JoinNow



// WEBPACK FOOTER //
// ./src/Components/JoinNow.js